module.exports = "<ion-app class=\"marginCenter\">\n  <ion-router-outlet></ion-router-outlet>\n</ion-app>"